import type { Course } from "@repo/app-types/entities/course";
import type { PlaybookTree } from "@repo/app-types/entities/playbook";
import type { TrainingChapterAssessment } from "@repo/app-types/entities/trainingChapterAssessment";
import { getTagsProvidedByList } from "../helpers/tags.js";
import { api } from "../redux.js";

const TrainingChapterAssessmentTagType = "TrainingChapterAssessment";
type TrainingChapterAssessmentTagType = typeof TrainingChapterAssessmentTagType;

const trainingChapterAssessmentApi = api
  .enhanceEndpoints({
    addTagTypes: [TrainingChapterAssessmentTagType],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      allTrainingChapterAssessmentsForProject: builder.query<
        {
          course: Course;
          assessableParticipantsCount: number;
          /** @deprecated Use the playbook fetched via the chapter assessment's recording_assessment_template_id instead. */
          assessmentTree: PlaybookTree | null;
          trainingChapterAssessments: TrainingChapterAssessment[];
        },
        { projectId: string },
        {
          data: {
            course: Course;
            assessable_participants_count: number;
            assessment_tree: PlaybookTree | null;
            training_chapter_assessments: TrainingChapterAssessment[];
          };
        }
      >({
        query: ({ projectId }) => ({
          method: "GET",
          url: `/training/${encodeURIComponent(projectId)}/chapters/assessments`,
        }),
        transformResponse: (response) => ({
          course: response.data.course,
          assessableParticipantsCount:
            response.data.assessable_participants_count,
          assessmentTree: response.data.assessment_tree,
          trainingChapterAssessments:
            response.data.training_chapter_assessments,
        }),
        providesTags: (result, error, { projectId }) =>
          getTagsProvidedByList(
            TrainingChapterAssessmentTagType,
            result?.trainingChapterAssessments,
            {
              filteredBy: [projectId],
            },
          ),
      }),
    }),
  });

export const { useAllTrainingChapterAssessmentsForProjectQuery } =
  trainingChapterAssessmentApi;
